import { Link, useLocation } from "react-router";
import { HIREOS_INQUIRY_URL } from "../../hireos-links";

const HIDDEN_PATHS = [
  "/collect-balance",
  "/pay-balance",
  "/pay-contractor",
  "/approve",
];

export function Footer() {
  const { pathname } = useLocation();
  if (HIDDEN_PATHS.some((p) => pathname.startsWith(p))) {
    return null;
  }

  return (
    <footer className="bg-gray-950 text-white">
      {/* Oversized quote CTA — the site-wide closing statement */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <p className="text-sm font-medium text-gray-400 mb-4">Got an event?</p>
        <p className="text-3xl sm:text-4xl md:text-6xl font-bold tracking-tight max-w-3xl mb-8 md:mb-10">
          Tell us about it. We&apos;ll sort the sound
          <span className="text-orange-600">.</span>
        </p>
        <a
          href={HIREOS_INQUIRY_URL}
          className="block sm:inline-block bg-orange-600 text-white px-8 py-4 rounded-md font-bold text-lg text-center"
        >
          Get a Quote
        </a>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
            <div className="flex flex-col sm:flex-row sm:items-center gap-6 sm:gap-8">
              <Link to="/" className="font-bold text-lg tracking-tight">
                Accent Productions
              </Link>
              <nav className="flex gap-6 text-sm text-gray-400 font-medium">
                <Link to="/services" className="cursor-pointer">
                  Services
                </Link>
                <Link to="/about" className="cursor-pointer">
                  About
                </Link>
                <Link to="/contact" className="cursor-pointer">
                  Contact
                </Link>
              </nav>
            </div>
            <div className="text-sm text-gray-400 space-y-1">
              <p>hello@accent-productions.co.nz</p>
              <p>
                <a href="tel:+64276023869" className="cursor-pointer">
                  +64 4 887 8650
                </a>
              </p>
            </div>
          </div>
          <div className="mt-8 pt-6 border-t border-white/10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-sm text-gray-500">
            <span>&copy; {new Date().getFullYear()} Accent Productions</span>
            <nav className="flex gap-4">
              <Link to="/terms" className="cursor-pointer">
                Terms
              </Link>
              <Link to="/privacy" className="cursor-pointer">
                Privacy
              </Link>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
}
